import { useChangeFromMedia } from 'common/helpers';
import React, { useState } from 'react';


function CompanyImage(props) {
  const { hoverSrc, src, image_alt } = props;
  const [ imgRrc, setImgSrc ] = useState(src);
  const isMobile = useChangeFromMedia(false, true, false, true, true);

  const handleMouseOver = () => {
    setImgSrc(hoverSrc);
  };

  const handleMouseOut = () => {
    setImgSrc(props.src);
  };

  return (
    <img
      draggable={false}
      src={isMobile ? hoverSrc : imgRrc}
      alt={image_alt}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      style={{ cursor: 'pointer', width: '100%', height: '100%' }}
    />
  );
}
export default CompanyImage;
